import { render, staticRenderFns } from "./IconLowChance.vue?vue&type=template&id=3cb8ddd5&"
import script from "./IconLowChance.vue?vue&type=script&lang=ts&"
export * from "./IconLowChance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports